module.exports = __webpack_public_path__ + "media/images/Padgett_CC_S-bb318a0eecdbda0523790c040b23f61f.png";